import React, { useState, useEffect } from 'react';

import { useRecoilState } from 'recoil';
import { pathAtom, gstrpathAtom, digErrorAtom, returnDateAtom, loadingAtom, gstrUserAtom, gstrQueryAtom, userIDAtom } from '../../../core/config/atoms';

import Moment from 'moment';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import ServiceOption from '../../../services/serviceOptions';
import ServiceGSTR from '../../../services/serviceGSTR';

import '../css/main.css';
import '../css/style.css';

import imgLoader from '../../../assets/images/cloading.gif';

export default function PanelB2COForm() {

    const [path, setPath] = useRecoilState(pathAtom);
    const [gstrPath, setGSTRPath] = useRecoilState(gstrpathAtom);
    const [digError, setDigError] = useRecoilState(digErrorAtom);
    const [gDate] = useRecoilState(returnDateAtom);
    const [loading, setLoading] = useRecoilState(loadingAtom);
    const [GSTUser] = useRecoilState(gstrUserAtom);
    const [query, setQuery] = useRecoilState(gstrQueryAtom);
    const [userID] = useRecoilState(userIDAtom);

    const [states, setStates] = useState([]);

    const [title, setTitle] = useState('Add');

    const [error, setError] = useState(false);
    const [isAlert, setIsAlrt] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [isItem, setIsItem] = useState(false);
    const [editid, setEditid] = useState('');

    const optionService = new ServiceOption();
    const returnService = new ServiceGSTR();

    const formVSchema = Yup.object().shape({
        pos: Yup.string().required('This information is required'),
        supplyty: Yup.string().required('This information is required'),
        invval: Yup.string().max(13, { message: 'Please enter valid amout' }).required('This information is required'),
        rate: Yup.string().required('This information is required'),
        taxa: Yup.string().when(["supplyty"], {
            is: (supplyty) => {
                return supplyty === "Inter-state";
            },
            then: Yup.string().required('This information is required'),
        }),
        taxb: Yup.string().when(["supplyty"], {
            is: (supplyty) => {
                return supplyty === "Intra-state";
            },
            then: Yup.string().required('This information is required'),
        }),
    });

    const { values, errors, touched, setValues, handleChange, handleSubmit, handleReset, resetForm } = useFormik({
        initialValues: {
            pos: '',
            supplyty: '',
            invval: '',
            rate: '',
            taxa: '',
            taxb: '',
            cess: '',
        },
        validationSchema: formVSchema,
        onSubmit: values => {
            let body = {};
            setSubmit(true);
            if (isEdit) {
                values.status = 'EDIT';
                body = {
                    id: editid,
                    data: values,
                }
                returnService.updateGstrDoc(body).then((res) => {
                    if (res.status) {
                        gotoGstrPath('b2coa');
                    } else {
                        setDigError({ title: 'Error', msg: 'Server error please try again!', isToggle: true });
                    }
                    setSubmit(false);
                });
            } else {
                values.status = 'ADD';
                body = {
                    month: gDate,
                    lid: userID,
                    type: 'b2co',
                    data: values,
                }
                returnService.setGstrDoc(body).then((res) => {
                    if (res.status) {
                        if (res.statuscode === 202) {
                            showError();
                            resetData(values);
                        } else {
                            showAlert();
                            resetData(values);
                        }
                    } else {
                        setDigError({ title: 'Error', msg: 'Server error please try again!', isToggle: true });
                    }
                    setSubmit(false);
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    });
                });
            }
        }
    });

    const gotoPath = (path) => {
        setLoading(true);
        setPath(path);
    }

    const gotoGstrPath = (path) => {
        setGSTRPath(path);
        gotoPath('gstrFile');
    }

    const getFormatvalue = (val) => {
        if (!val) return val;
        let number = val.replace(/[^\d.]/g, "");
        if (val.includes(".")) {
            const a = number.split(".");
            if (a[1].length > 2) {
                a[1] = a[1].substring(0, 2);
            }
            if (a[0].length > 11) {
                a[0] = a[0].substring(0, 11);
            }
            number = a[0] + "." + a[1];
        } else {
            if (number.length > 11) {
                number = number.substring(0, 11);
            }
        }
        return number;
    }

    const showAlert = () => {
        setIsAlrt(true);
        setTimeout(
            () => setIsAlrt(false),
            5000
        );
    }

    const showError = () => {
        setError(true);
        setTimeout(
            () => setError(false),
            5000
        );
    }

    const resetData = (val) => {
        resetForm();
        setIsEdit(false);
        setIsItem(false);
        setValues({
            pos: '',
            supplyty: '',
            invval: '',
            rate: '',
            taxa: '',
            taxb: '',
            cess: '',
        });
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    const loadData = () => {
        (async function () {
            var resB = await optionService.getStates({});
            setStates(resB.data);

            if (query.type === 'edit') {
                let body = {
                    id: query.data
                };
                var doc = await returnService.getGstrDocById(body);
                setValues({ ...values, ...doc.data.data });
                setIsItem(true);
                setIsEdit(true);
                setEditid(doc.data._id);
                setQuery({ type: '', data: '' });
                setTitle('Edit');
            } else {
                setIsItem(false);
                setIsEdit(false);
                setQuery({ type: '', data: '' });
                setTitle('Add');
            }

            setLoading(false);
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div class="content-wrapper fade-ng-cloak">
            <div class="dimmer-holder" style={{ display: 'none' }}>
                <div id="dimmer"></div>
            </div>
            {
                loading && <div className='absolute z-50 w-full h-screen flex items-center justify-center bg-gray-200 bg-opacity-25'>
                    <img src={imgLoader} alt="loader" />
                </div>
            }
            <div class="container">
                <div class="mypage">
                    <div class="row" data-ng-controller="transctrl" data-ng-init="init('returns')">
                        <div class="col-xs-10">
                            <div data-breadcrumb="" name="Dashboard">
                                <ol class="breadcrumb" data-ng-controller="crumbCtrl">
                                    <li><a onClick={() => {
                                        gotoPath('gstr')
                                    }}>Dashboard</a></li>
                                    <li><a onClick={() => {
                                        gotoPath('gstRetrun')
                                    }}>Returns</a></li>
                                    <li><a onClick={() => {
                                        gotoPath('gstrForm')
                                    }}>GSTR-1/IFF</a></li>
                                    <li>B2CS</li>
                                </ol>
                            </div>
                        </div>
                        <div class="col-xs-2">
                            <div class="lang dropdown">
                                <span class="dropdown-toggle" data-toggle="dropdown" data-ng-bind="selectedLang">English</span>
                                <ul class="dropdown-menu lang-dpdwn">
                                    <li data-ng-repeat="language in languages">
                                        <a data-ng-click="selectLang(language.cd)" data-ng-bind="language.nm">English</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div data-ng-controller="mainctrl" ng-view="">
                        <div data-ng-init="editData()">
                            <form name="b2cs" autocomplete="off" novalidate="" onSubmit={handleSubmit} onReset={handleReset}>
                                <div class="row invsumm">
                                    <div data-ng-if="!rateEditable" class="col-sm-12 col-xs-12 taxp">
                                        <h4 data-ng-bind="trans.HEAD_B2CS">B2CS - {title} Details</h4>
                                        <span data-toggle="modal" data-target="#b2csModal"><a href="#" type="button" title="Help" data-toggle="tooltip"><i class="fa fa-question-circle" aria-hidden="true"></i></a></span>
                                    </div>
                                </div>
                                <div class="tabpane">
                                    <p class="mand-text" data-ng-bind="trans.HLP_MAND_FIELD">Indicates Mandatory Fields</p>
                                    {isAlert && <alert-message ng-show="showMsg" title="" type="msg alert-success" message="" class="ng-hide"><div class="alert alert-msg alert-success">Request accepted successfully<a class="close" onClick={() => { setIsAlrt(false) }} data-dismiss="alert" aria-label="close">×</a><strong></strong>.</div></alert-message>}
                                    {error && <alert-message ng-show="showMsg" title="" type="msg alert-danger" message="" class="ng-hide"><div class="alert alert-msg alert-danger">State data already exist<a class="close" onClick={() => { setError(false) }} data-dismiss="alert" aria-label="close">×</a><strong></strong>.</div></alert-message>}
                                    <div class="tbl-format rettbl-format">
                                        <div class="row">
                                            <div class={`col-sm-4 ${touched.pos ? errors.pos ? 'has-error' : 'has-success' : ''}`}>
                                                <label class="reg m-cir" for="pos">
                                                    <span data-ng-bind="trans.LBL_POS">POS</span><i class="fa fa-info-circle" title="Place of Supply(Only if different from location of recipient)"></i>
                                                </label>
                                                <select name="pos" class="form-control" value={values.pos} id="pos" onChange={e => {
                                                    let val = e.target.value;
                                                    let isIn = false;
                                                    values.pos = val;
                                                    if (val === GSTUser.state) {
                                                        setIsItem(true);
                                                        isIn = true;
                                                        values.supplyty = "Intra-state";
                                                    } else {
                                                        setIsItem(true);
                                                        isIn = false;
                                                        values.supplyty = "Inter-state";
                                                    }
                                                    if (values.rate === "") {
                                                        values.taxa = '';
                                                        values.taxb = '';
                                                        values.cess = '';
                                                    } else {
                                                        if (values.invval === "") {
                                                            values.taxa = 0;
                                                            values.taxb = 0;
                                                        } else {
                                                            if (isIn) {
                                                                values.taxa = 0;
                                                                values.taxb = ((values.invval * (parseFloat(values.rate) / 100)) / 2).toFixed(2);
                                                            } else {
                                                                values.taxa = (values.invval * (parseFloat(values.rate) / 100)).toFixed(2);
                                                                values.taxb = 0;
                                                            }
                                                        }
                                                    }
                                                    setValues(values);
                                                }} disabled={isEdit}>
                                                    <option value="" selected="selected" disabled="">Select</option>
                                                    {
                                                        states.length !== 0 && states.map((s) => {
                                                            return <option value={s} selected={values.pos == s}>{s}</option>
                                                        })
                                                    }
                                                </select>
                                                {(errors.pos && touched.pos) && <span className='err'>{errors.pos}</span>}
                                            </div>
                                            <div class={`col-sm-4 ${touched.invval ? errors.invval ? 'has-error' : 'has-success' : ''}`}>
                                                <label class="reg m-cir" for="invval" data-ng-bind="trans.LBL_TAX_VALUE">Taxable value (₹)</label>
                                                <input name="invval" class="form-control newinv formedit text-right" title="currency" required="required" id="invval" maxLength={16} value={values.invval} onChange={e => {
                                                    const formatValue = getFormatvalue(e.target.value);
                                                    e.target.value = formatValue;
                                                    if (e.target.value === "") {
                                                        values.taxa = '';
                                                        values.taxb = '';
                                                        values.cess = '';
                                                    } else {
                                                        if (values.rate === "") {
                                                            values.taxa = 0;
                                                            values.taxb = 0;
                                                        } else {
                                                            if (values.supplyty === "Intra-state") {
                                                                values.taxa = 0;
                                                                values.taxb = (parseFloat(e.target.value) * (values.rate / 100)).toFixed(2);
                                                            } else {
                                                                values.taxa = (parseFloat(e.target.value) * (values.rate / 100)).toFixed(2);
                                                                values.taxb = 0;
                                                            }
                                                        }
                                                    }
                                                    handleChange(e);
                                                }} onBlur={e => {
                                                    if (e.target.value.length != 0 && !e.target.value.includes(".")) {
                                                        e.target.value = e.target.value + ".00";
                                                    }
                                                    handleChange(e);
                                                }} />
                                                {(errors.invval && touched.invval) && <span className='err'>{errors.invval}</span>}
                                            </div>
                                            <div class="row">
                                                <div class={`col-sm-4 ${touched.supplyty ? errors.supplyty ? 'has-error' : 'has-success' : ''}`}>
                                                    <label class="reg" for="stype" data-ng-bind="trans.LBL_SUPPLY_TYPE">Supply Type</label>
                                                    <input class="form-control" name="supplyty" id="supplyty" readOnly={true} value={values.supplyty} />
                                                    {(errors.supplyty && touched.supplyty) && <span className='err'>{errors.supplyty}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-8">
                                                <br />
                                                <input type="checkbox" class="chkbx ng-pristine ng-untouched ng-valid ng-empty" id="rate_flag" data-ng-model="rate_flag" data-ng-checked="rate_flag=='Y'" data-ng-true-value="'Y'" data-ng-false-value="'N'" data-ng-change="cleartaxes();dupinvclear();" data-ng-disabled="rateEditable" disabled={true} />
                                                <label for="rate_flag">Is the supply eligible to be taxed at a differential percentage (%) of the existing rate of tax, as notified by the Government?</label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class={`col-sm-4 ${touched.rate ? errors.rate ? 'has-error' : 'has-success' : ''}`}>
                                                <label class="reg m-cir" for="rate">Rate</label>
                                                <select class="form-control newinv formedit" name="rate" id="rate" onChange={(e) => {
                                                    let rate = e.target.value;
                                                    if (e.target.value === "") {
                                                        values.taxa = '';
                                                        values.taxb = '';
                                                        values.cess = '';
                                                    } else {
                                                        if (values.invval === "") {
                                                            values.taxa = 0;
                                                            values.taxb = 0;
                                                        } else {
                                                            if (values.supplyty === "Intra-state") {
                                                                values.taxa = 0;
                                                                values.taxb = ((values.invval * (parseFloat(rate) / 100)) / 2).toFixed(2);
                                                            } else {
                                                                values.taxa = (values.invval * (parseFloat(rate) / 100)).toFixed(2);
                                                                values.taxb = 0;
                                                            }
                                                        }
                                                    }
                                                    handleChange(e);
                                                }} value={values.rate} required="" disabled={isEdit}>
                                                    <option label="Select" value="" disabled="" selected="selected"></option>
                                                    <option label="0" value="0">0</option>
                                                    <option label="0.1" value="0.1">0.1</option>
                                                    <option label="0.25" value="0.25">0.25</option>
                                                    <option label="1" value="1">1</option>
                                                    <option label="1.5" value="1.5">1.5</option>
                                                    <option label="3" value="3">3</option>
                                                    <option label="5" value="5">5</option>
                                                    <option label="6" value="6">6</option>
                                                    <option label="7.5" value="7.5">7.5</option>
                                                    <option label="12" value="12">12</option>
                                                    <option label="18" value="18">18</option>
                                                    <option label="28" value="28">28</option>
                                                </select>
                                                {(errors.rate && touched.rate) && <span className='err'>{errors.rate}</span>}
                                            </div>
                                        </div>
                                        {
                                            isItem && <div class="row">
                                                {
                                                    values.supplyty === "Inter-state" && <div class={`col-sm-4 ${touched.taxa ? errors.taxa ? 'has-error' : 'has-success' : ''}`}>
                                                        <label class="reg m-cir" for="stype" data-ng-bind="trans.LBL_SUPPLY_TYPE">Integrated tax (₹)</label>
                                                        <input id="taxa" class="form-control newinv formedit currency" maxLength={16} value={values.taxa} onChange={e => {
                                                            const formatValue = getFormatvalue(e.target.value);
                                                            e.target.value = formatValue;
                                                            handleChange(e);
                                                        }} onBlur={e => {
                                                            if (e.target.value.length != 0 && !e.target.value.includes(".")) {
                                                                e.target.value = e.target.value + ".00";
                                                            }
                                                            handleChange(e);
                                                        }} disabled={values.invval === ""} />
                                                        {(errors.taxa && touched.taxa) && <span className='err'>{errors.taxa}</span>}
                                                    </div>
                                                }
                                                {
                                                    values.supplyty === "Intra-state" && <>
                                                        <div class={`col-sm-4 ${touched.taxb ? errors.taxb ? 'has-error' : 'has-success' : ''}`}>
                                                            <label class="reg m-cir" for="stype" data-ng-bind="trans.LBL_SUPPLY_TYPE">Central tax (₹)</label>
                                                            <input id="taxb" class="form-control newinv formedit currency" maxLength={16} value={values.taxb} onChange={e => {
                                                                const formatValue = getFormatvalue(e.target.value);
                                                                e.target.value = formatValue;
                                                                handleChange(e);
                                                            }} onBlur={e => {
                                                                if (e.target.value.length != 0 && !e.target.value.includes(".")) {
                                                                    e.target.value = e.target.value + ".00";
                                                                }
                                                                handleChange(e);
                                                            }} disabled={values.invval === ""} />
                                                            {(errors.taxb && touched.taxb) && <span className='err'>{errors.taxb}</span>}
                                                        </div>
                                                        <div class={`col-sm-4 ${touched.taxb ? errors.taxb ? 'has-error' : 'has-success' : ''}`}>
                                                            <label class="reg m-cir" for="stype" data-ng-bind="trans.LBL_SUPPLY_TYPE">State tax (₹)</label>
                                                            <input id="taxb" class="form-control newinv formedit currency" maxLength={16} value={values.taxb} onChange={e => {
                                                                const formatValue = getFormatvalue(e.target.value);
                                                                e.target.value = formatValue;
                                                                handleChange(e);
                                                            }} onBlur={e => {
                                                                if (e.target.value.length != 0 && !e.target.value.includes(".")) {
                                                                    e.target.value = e.target.value + ".00";
                                                                }
                                                                handleChange(e);
                                                            }} disabled={values.invval === ""} />
                                                            {(errors.taxb && touched.taxb) && <span className='err'>{errors.taxb}</span>}
                                                        </div>
                                                    </>
                                                }
                                                <div class="col-sm-4">
                                                    <label class="reg" for="stype" data-ng-bind="trans.LBL_SUPPLY_TYPE">Cess (₹)</label>
                                                    <input id="cess" class="form-control newinv formedit currency" maxLength={16} value={values.cess} onChange={e => {
                                                        const formatValue = getFormatvalue(e.target.value);
                                                        e.target.value = formatValue;
                                                        handleChange(e);
                                                    }} onBlur={e => {
                                                        if (e.target.value.length != 0 && !e.target.value.includes(".")) {
                                                            e.target.value = e.target.value + ".00";
                                                        }
                                                        handleChange(e);
                                                    }} disabled={values.invval === ""} />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 col-xs-12 text-right next-tab-nav">
                                            <button type="button" class="btn btn-default" data-ng-bind="trans.LBL_BACK" data-ng-click="page_b2cs(ecomgstin)" onClick={() => {
                                                gotoGstrPath('b2coa')
                                            }}>Back</button>&nbsp;
                                            <button type="submit" class="btn btn-primary accpt" data-ng-bind="trans.LBL_SAVE">Save</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
